import { markerToCircleMarkerPaint } from "utilities/mapbox_style_adapters";
import { featureCollection as toFeatureCollection } from '@turf/turf';
import { merge } from 'lodash';
import generateId from "utilities/random_id_generator";

export default class PointMarker {
  defaultMarkerOptions = {
    "paint": {
      "circle-radius": 8,
      "circle-color": "#00FF00",
      "circle-opacity": 0.7,
      "circle-stroke-width": 2,
      "circle-stroke-color": "#fff",
      "circle-pitch-alignment": "map"
    }
  };

  constructor({ point = null, map, style = null }) {
    this.id = generateId();
    this.map = map;
    this.point = point;
    this.styleOptions = merge(
      this.defaultMarkerOptions,
      markerToCircleMarkerPaint(style || {})
    );
  }

  set point(point) {
    if (point) {
      if (point.geometry && point.geometry.type != "Point") throw "Must pass Point feature";

      const featureCollection = toFeatureCollection([point]);
      const source = this.map.getSource(this.sourceId());

      this.pointGeometry = point.geometry;

      if (source) {
        source.setData(featureCollection);
      } else {
        this.map.addSource(this.sourceId(), {
          'type': 'geojson',
          'data': featureCollection
        });
      }
    } else if (this.map.getSource(this.sourceId())) {
      this.pointGeometry = null;
      this.remove();
    }
  }

  isShowing() {
    return !!this.map.getLayer(this.layerId());
  }

  show() {
    if (this.isShowing()) return;

    this.map.addLayer({
      'id': this.layerId(),
      'type': 'circle',
      'source': this.sourceId(),
      ...this.styleOptions
    });
  }

  hide() {
    if (!this.isShowing()) return;

    this.map.removeLayer(this.layerId());
  }

  remove() {
    if (!this.map.getSource(this.sourceId())) return;

    this.hide();
    this.map.removeSource(this.sourceId());
  }

  pixelPoint() {
    return this.map.project(this.coordinates());
  }

  layerId() {
    return `point-marker-layer-${this.id}`;
  }

  sourceId() {
    return `point-marker-source-${this.id}`;
  }

  coordinates() {
    if (this.pointGeometry) {
      return this.pointGeometry.coordinates;
    } else {
      return null;
    }
  }
}
